const FeesStructure = () => {
    return (
        <div id="fees" className="vision-card">
            <h3>FEES STRUCTURE</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th colSpan="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    <span>FEES</span>

                                    <div style={{ textAlign: "right" }}>
                                        <div>09308-N J MISSION SCH PO KASIA KUSHINAGAR UP</div>
                                        <div>Date: 15-12-2016</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <br />

                        <tr>
                            <th>CLASS</th>
                            <th>ADMISSION FEE (IN RUPEES)</th>
                            <th>TUITION FEE (IN RUPEES)</th>
                            <th>YEARL Y DEVELOPMENT CHARGES (IN RUPEES)</th>
                            <th>ANNUAL/MONTHL Y OTHER CHARGES FOR OTHER FACILITIES (IN RUPEES)</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>PRIMARY</td>
                            <td>500</td>
                            <td>120000</td>
                            <td>2000</td>
                            <td>1500</td>
                        </tr>

                        <tr>
                            <td>MIDDLE</td>
                            <td>500</td>
                            <td>14400</td>
                            <td>2000</td>
                            <td>1500</td>
                        </tr>

                        <tr>
                            <td>SECONDARY</td>
                            <td>600</td>
                            <td>26100</td>
                            <td>2500</td>
                            <td>3000</td>
                        </tr>

                        <tr>
                            <td>SENIOR SECONDARY</td>
                            <td>600</td>
                            <td>26100</td>
                            <td>2500</td>
                            <td>3500</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FeesStructure;